import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import * as globalActions from './global.actions';
import { mergeMap, map, catchError, find, tap, filter, exhaustMap, switchMap, delay, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../../modulos/auth/services/auth.service';
import { AlertService } from '../../services/alert.service';
import { HttpResponse } from '@angular/common/http';
import { AmbienteService } from 'src/app/modulos/catalogos-admin/services/ambiente.service';
import { PlanInstitucionalService } from 'src/app/modulos/catalogos-admin/services/plan-institucional.service';
import { PlanAniosInterface } from 'src/app/modulos/catalogos-admin/models/plan.anios.interface';
import { PlanAniosService } from 'src/app/modulos/catalogos-admin/services/plan-anios.service';
import { AniosObjetivosService } from 'src/app/modulos/catalogos-admin/services/anios-objetivos.service';
import { elementoNivelPermiso } from './global.actions';
import { ElementoNivelPermisoService } from '../../modulos/admin/services/elemento.nivel.permiso.service';


@Injectable({
    providedIn: 'root'
})
export class GlobalEffects {

    constructor(
        private actions$: Actions,               
        private router: Router,
        private alert: AlertService,
        private ambienteService: AmbienteService,
        private planAniosService: AniosObjetivosService,
        private planInstitucionalService: PlanInstitucionalService,
        private planAniosInstitucionalService: PlanAniosService,
        private elementoNivelPermisoService: ElementoNivelPermisoService,

    ) { }

    ambiente$ = createEffect(() => this.actions$.pipe(
        ofType(globalActions.ambienteSeleccionado),
        
                map((response) => {
                    return globalActions.ambienteSeleccionadoSuccess({ ambiente: response.ambiente, rol: response.rol})
                }
                ),               
                catchError((err)=> 
                {
                    this.alert.alert(err+": Ambiente no encontrado", "Ups!", "error");
                    return of(globalActions.ambienteSeleccionadoError({ payload: err }))
                }),
    ));

   
    planInstitucional$ = createEffect(() => this.actions$.pipe(
        ofType(globalActions.planInstitucionalSeleccionado),
        mergeMap((resp) =>
            this.planInstitucionalService.getPlanInstitucionalId(resp.idPlan).pipe(
                map((response) => {
                    return globalActions.planInstitucionalSeleccionadoSuccess({ plan:response })
                }
                ),               
                catchError((err)=> 
                {
                    this.alert.alert(err+": Plan institucional no encontrado", "Ups!", "error");
                    return of(globalActions.planAniosSeleccionadoError({ payload: err }))
                }),
            ))
    ));

    planAniosInstitucional$ = createEffect(() => this.actions$.pipe(
        ofType(globalActions.planAniosSeleccionado),
        mergeMap((resp) =>
            //this.planAniosInstitucionalService.getPlanAniosId(resp.idPlan).pipe(
            this.planAniosService.getPlanAniosId(resp.idPlan).pipe(
                map((response) => {
                    return globalActions.planAniosSeleccionadoSuccess({ plan: response })
                }
                ),               
                catchError((err)=> 
                {
                    this.alert.alert(err+": Plan no encontrado", "Ups!", "error");
                    return of(globalActions.planAniosSeleccionadoError({ payload: err }))
                }),
            ))
    ));

   
    Permis$ = createEffect(() => this.actions$.pipe(
        ofType(globalActions.elementoNivelPermiso),
        mergeMap((resp) =>
            //this.planAniosInstitucionalService.getPlanAniosId(resp.idPlan).pipe(
            this.elementoNivelPermisoService.list(`?estado=1`).pipe(
                map((response) => {
                    return globalActions.elementoNivelPermisoSuccess({ elementNivelPermis: response })
                }
                ),               
                catchError((err)=> 
                {
                    this.alert.alert(err+": Elemento nivel permiso", "Ups!", "error");
                    return of(globalActions.elementoNivelPermisoError({ payload: err }))
                }),
            ))
    ));
}